import React, { useState } from "react";
import {
  DialogContent,
  DialogTitle,
  Dialog,
  Button,
  Grid,
  Tooltip,
  DialogActions,
  Typography,
} from "@material-ui/core";
import Loader from "./Loader";
import axios from "axios";
import { History } from "@material-ui/icons";

const UptimePingDevice = (props) => {
  const [loading, setLoading] = useState(false);
  const { deviceData, setMessage, setError } = props;
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const setAutoRestartDevice = () => {
    setLoading(true);
    axios
      .post(`/device/autorestart?device_serial=${deviceData?.serial}`)
      .then((response) => {
        if (response.status === 200) {
          setMessage("Uptime-Restart for device queued successfully");
        } else {
          setError("Error setting Uptime-Restart");
        }
      })
      .catch((error) => {
        setError("Error setting Uptime-Restart");
      })
      .finally(() => {
        setLoading(false);
        handleClose();
      });
  };

  if (loading) {
    return <Loader />;
  } else {
    return (
      <React.Fragment>
        <Grid item>
          <Tooltip title="Install Uptime-Restart for device">
            <Button
              onClick={() => setOpen(true)}
              color="secondary"
              variant="contained"
              disabled={!deviceData}
              startIcon={<History />}
              style={{ marginRight: "12px" }}
            >
              Install Uptime-Restart
            </Button>
          </Tooltip>
        </Grid>
        <Dialog
          onClose={handleClose}
          open={open}
          aria-labelledby="simple-dialog-title"
          fullWidth={false}
          maxWidth={"lg"}
        >
          <DialogTitle id="simple-dialog-title">
            Install Uptime-Restart {deviceData?.name}
          </DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to install uptime-restart script to the device with serial no:{" "}
              {deviceData?.serial}?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={setAutoRestartDevice} color="primary">
              Install
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
};

export default UptimePingDevice;
